import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Callback from './views/Callback.vue'
import Registrations from './views/Registrations.vue'
import Settings from './views/Settings.vue'
import Approvals from './views/Approvals.vue'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/reg/:nav?/:time?',
      name: 'reg',
      component: Registrations
    },
    {
      path: '/settings/:nav?/:nav2?',
      name: 'settings',
      component: Settings
    },
    {
      path: '/approvals/:nav?',
      name: 'approvals',
      component: Approvals
    }
  ]
})

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  if(to.name == 'callback') { // check if "to"-route is "callback" and allow access
    next()
  } else if (router.app.$auth.isAuthenticated()) { // if authenticated allow access
    if (to.name == 'home' || to.path == '/home') {
      next({ path: 'reg' })
    }
    next()
  }
    else { // trigger auth0 login
    router.app.$auth.login()
  }
})

export default router